import EditPersonalInfoForm from "@/components/modules/account/edit-personal-info-form";
import { __ } from "@/lib/i18n/functions";

type EditPersonalInfoFormProps = {
  resolution: Resolution;
};

const AccountInfoEdit = ({ resolution }: EditPersonalInfoFormProps) => {
  const locale = resolution?.locale;
  return (
    <article className="text-dark-primary flex-1/2 space-y-[70px]">
      <section className="space-y-5">
        <div className="flex items-center justify-between">
          <h2 className="font-cabinet-grotesk text-2xl font-medium md:text-3xl">{__("My information", locale)}</h2>
        </div>
        <EditPersonalInfoForm locale={resolution.locale} />
      </section>
    </article>
  );
};

export default AccountInfoEdit;
